import { BsChatSquareDotsFill,   } from "react-icons/bs";
import { GiMissileLauncher   } from "react-icons/gi";
import { FaThList, FaUserGraduate, FaCode, FaPenNib, FaConnectdevelop } from "react-icons/fa";

const processData = [
    {
        id: 1,
        processName: "GETTING STARTED",
        stepIcon1: <FaThList />,
        stepTitle1: "Brief",
        stepDescription1: "To get a clear picture of what you need I start every project by receiving an initial brief of what you want. Having this gives me enough context to properly provide you with a proposal and ultimately tailor my services to your project goals.",
        stepIcon2: <BsChatSquareDotsFill />,
        stepTitle2: "Initial Chat",
        stepDescription2: "The next step is to have a quick 15-minute call so we can properly introduce ourselves and make sure we're both on the same page. This is the perfect time to let me know anything I might need to be aware of during the project."
    },
    {
        id: 2,
        processName: "DESIGN",
        stepIcon1: <FaConnectdevelop />,
        stepTitle1: "Wireframes",
        stepDescription1: "Having a good set of wireframes is the bedrock of any successful website project. This is where we hammer down the layout and general functionality while always making sure the user is the primary focus.",
        stepIcon2: <FaPenNib />,
        stepTitle2: "Designs",
        stepDescription2: "This is where I apply the paint to your website. I'll take the concepts we've agreed on in the wireframes to make them look usable, modern and clean."
    },
    {
        id: 3,
        processName: "DEVELOPMENT & LAUNCH",
        stepIcon1: <FaCode />,
        stepTitle1: "Code",
        stepDescription1: "When the coding begins there will generally be less communication from me as this is quite an involved process that doesn't require much feedback. This is where I take the visuals of your website and make them into something real that people can interact with.",
        stepIcon2: <FaUserGraduate/>,
        stepTitle2: "Training",
        stepDescription2: "After the website has been coded but before it goes live I like to provide in-depth training. Going forward your website will be easily updatable by yourself so I'll take you through everything over the phone and even provide screencasts for you to keep.",
        stepIcon3: <GiMissileLauncher/>,
        stepTitle3: "Launch",
        stepDescription3: "When it's time to launch the new site I'll take care of everything. All you'll need to do is get that Tweet ready about your shiny new website!"
    },
]


export default processData